import { useHMSRoom } from "../hms";
import { useLivekitRoom } from "../livekit";
import type { ProviderRoomParams } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderRoom = (params: ProviderRoomParams) =>
  useProviderHook({
    hms: useHMSRoom,
    livekit: useLivekitRoom,
  })(params);
